import { render, staticRenderFns } from "./TrusteeForeignOrganization.vue?vue&type=template&id=26aeabe4&"
import script from "./TrusteeForeignOrganization.vue?vue&type=script&lang=js&"
export * from "./TrusteeForeignOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports